var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n        stroke: #fff;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 9px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M124.5,241.58c64.84,0,117.6-52.76,117.6-117.6S191.96,8.31,127.95,6.42h-.19c-3.35,0-6.12,2.67-6.22,6.05-.1,3.44,2.61,6.31,6.05,6.41,57.23,1.68,102.06,47.84,102.06,105.1s-47.17,105.15-105.15,105.15S19.36,181.95,19.36,123.98c0-28.89,12.08-56.56,32.8-76.26v18.95c0,3.44,2.79,6.23,6.23,6.23s6.23-2.79,6.23-6.23v-32.31c0-.24-.11-.45-.14-.68-.05-.43-.12-.83-.25-1.24-.14-.41-.32-.78-.54-1.15-.12-.2-.15-.43-.29-.63-.09-.13-.23-.19-.33-.3-.28-.33-.61-.6-.95-.87-.31-.23-.6-.46-.94-.63-.35-.18-.71-.28-1.09-.39-.42-.12-.82-.22-1.25-.25-.16-.01-.29-.09-.45-.09H26.21c-3.44,0-6.23,2.79-6.23,6.23s2.79,6.23,6.23,6.23h15.46C19.68,62.48,6.9,92.57,6.9,123.98c0,64.84,52.75,117.6,117.6,117.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedo);
export default __webpack_public_path__ + "static/media/redo.3b6369ab2a0a30a8bda22caa01070e5c.svg";
export { ForwardRef as ReactComponent };